import React, { useState } from 'react';
import './favoriteButton.scss';
import { ReactComponent as Favorite } from '../../assets/favorite.svg';
import { FaivoriteInterface } from './favoriteIconTypes';

const FavoriteButton: React.FC<FaivoriteInterface> = ({
  onClick,
  alreadyFavorite,
  disabledStatus,
}) => {
  const [isFavorite, setIsFavorite] = useState<boolean>(
    alreadyFavorite || false
  );

  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.stopPropagation();
    setIsFavorite(!isFavorite);
    onClick();
  };

  const buttonClass = !disabledStatus
    ? 'favoriteButton favoriteButtonDisabled'
    : 'favoriteButton';

  return (
    <button className={buttonClass} type="button" onClick={handleClick}>
      <Favorite
        className={`${!isFavorite ? 'favoriteIcon' : 'favoriteIconActive'}`}
      />
    </button>
  );
};

export default FavoriteButton;
